// LegalInfo.jsx — franja de datos legales (última actualización, régimen tributario,
// protección de datos, pasarelas) y aviso informativo, debajo de la sección FAQ.

import React from 'react'

function LegalInfo({ bootstrap = null }) {
  const [lastUpdated, setLastUpdated] = React.useState("Mayo 2026");

  React.useEffect(() => {
    if (bootstrap === undefined) return; // esperando el fetch consolidado de App
    if (bootstrap) {
      if (bootstrap.site_settings?.legal_last_updated) setLastUpdated(bootstrap.site_settings.legal_last_updated);
      return;
    }
    fetch("/api/site_settings")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.legal_last_updated) setLastUpdated(data.legal_last_updated);
      })
      .catch(() => {});
  }, [bootstrap]);

  return (
    <section style={{ paddingTop: 64, paddingBottom: 64, borderTop: "1px solid var(--line)" }}>
      <div className="wrap">
        <div
          className="legal-info-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 3fr",
            gap: 24,
          }}
        >
          <div className="card" style={{ padding: 24 }}>
            <div className="kicker">Última actualización</div>
            <div style={{ fontSize: 13.5, marginTop: 4 }}>{lastUpdated}</div>
          </div>

          <div className="card" style={{ padding: 24, fontSize: 12, color: "var(--fg-dim)", lineHeight: 1.55 }}>
            La información publicada en este portal tiene carácter informativo. Para asuntos tributarios específicos, te recomendamos
            consultar con tu contador o asesor de confianza. El Cuerpo de Bomberos de Quilpué se reserva el derecho de actualizar
            estos textos cuando corresponda; toda modificación se publica en esta misma página con su fecha.
          </div>
        </div>
      </div>
    </section>
  );
}

export { LegalInfo };
